<template>
	<div class="faq-wrapper">
		<div class="faq-title">
			<h4 class="heading-normal">
				{{ $t('wallet.faq') }}
			</h4>
			<a :href="faqAll.faqAll.url" target="_blank" class="view-all text-uppercase" @click="handleViewAllFaq">
				{{ $t('wallet.view-all-faq') }}
				<svgIcon icon-holder-class="icon-faq" icon-id="icon-page-right-blue" />
			</a>
		</div>

		<Accordion v-if="faqs.length > 0 || region === 'global'" one-at-atime>
			<Panel
				v-for="(item, index) in faqs"
				:key="index"
				class="help-panel"
				open-icon-id="icon-btn-minus"
				close-icon-id="icon-btn-plus"
				:header="item.question[`${$i18n.locale}`] ? item.question[`${$i18n.locale}`] : item.question.en"
				@open="panelOpen(item.question.en)"
			>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<div v-html="item.answer[`${$i18n.locale}`] ? item.answer[`${$i18n.locale}`] : item.answer.en"></div>
			</Panel>
			<!-- hardcoded faq option for the epin and nexon game cards: -->
			<Panel
				v-if="region === 'global' && getEpinNexonCardsToken"
				class="help-panel"
				open-icon-id="icon-btn-minus"
				close-icon-id="icon-btn-plus"
				:header="
					$t('wallet.faq-epin-nexoncards-title', {
						epin: $t('wallet.epin'),
						nexonGameCard: $t('wallet.legacy-nexon-game-card'),
					})
				"
				@open="panelOpen($t('wallet.faq-epin-nexoncards-title', 'en'))"
			>
				<div class="nx-another-way">
					<div>
						{{
							$t('wallet.faq-epin-nexoncards-line-1', {
								epin: $t('wallet.epin'),
								nexonGameCards: $t('wallet.legacy-nexon-game-card'),
							})
						}}
					</div>
					<i18n path="wallet.faq-epin-nexoncards-line-2" tag="div">
						<template v-slot:epin>
							<button
								id="epin"
								:class="{ disabled: disabledPayments }"
								:disabled="disabledPayments"
								@click="getEpinNexonCardsToken(methodCode.epin)"
							>
								{{ $t('wallet.epin') }}
							</button>
						</template>

						<template v-slot:nexonGameCard>
							<button
								id="nexoncards"
								:class="{ disabled: disabledPayments }"
								:disabled="disabledPayments"
								@click="getEpinNexonCardsToken(methodCode.nexonCards)"
							>
								{{ $t('wallet.legacy-nexon-game-card') }}
							</button>
						</template>
					</i18n>
				</div>
			</Panel>
		</Accordion>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import faqAll from '../../config/add-balance-faq-all';
import { Accordion, Panel } from '@arena/toolkit';

export default {
	name: 'FaqWidget',
	components: {
		svgIcon,
		Accordion,
		Panel,
	},
	props: {
		getEpinNexonCardsToken: {
			type: Function,
			default: null,
		},
		disabledPayments: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			faqAll: faqAll[environment.region],
			faqs: [],
			methodCode: {
				nexonCards: 'PMLC04',
				epin: 'PMLC05',
			},
		};
	},
	computed: {
		region() {
			return environment.region;
		},
	},
	created() {
		this.$faqAPI.getFaqList().then((response) => {
			this.faqs = response;
		});
	},
	methods: {
		panelOpen(title) {
			this.$a2s.click('faq_detail', {
				name: 'faq_title',
				value: title,
			});
			dataLayer.push({
				event: 'Add Balance FAQ',
				'FAQ Name': title,
			});
		},
		handleViewAllFaq(e) {
			e.preventDefault();
			this.$a2s.click('faq_more');
			window.location.href = e.target.href;
		},
	},
};
</script>

<style lang="less" scoped>
.faq-wrapper {
	margin-top: 46px;
	.faq-title {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
		border-bottom: 2px solid #999999;
		padding-bottom: 15px;
		h4 {
			font-size: 16px;
			font-weight: 700;
			color: #fff;
			margin: 0;
		}

		.view-all {
			font-size: 12px;
			display: flex;
			position: relative;
			align-items: center;
			color: #0077ff;
			font-weight: bold;
			margin-top: 4px;
			.icon-faq {
				width: 10px;
				height: 10px;
				transition: 0.3s ease;
				opacity: 0.7;
				margin-left: 5px;
			}
			&:hover {
				color: #4ca1ff;
				.icon-faq {
					opacity: 1;
				}
			}
		}
	}

	.panel-group {
		.panel {
			background-color: transparent;
			border-top: none;
			border-left: none;
			border-right: none;
			border-bottom: 1px solid #383838;
			border-radius: 0;
			color: #8c8c8c;
			:deep(.panel-heading) {
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				justify-content: space-between;
				background-color: transparent;
				line-height: 1;
				padding: 16px 0px 17px 0px;
				color: #8c8c8c;
				font-size: 14px;
				.icon-faq {
					width: 12px;
					height: 12px;
					min-width: 12px;
					margin-left: 20px;
				}
				&:hover {
					color: #d9d9d9;
				}
				@media (max-width: 599px) {
					font-size: 14px;
				}
			}
			:deep(.panel-collapse) {
				.panel-body {
					border: none;
					padding: 15px 0px 20px 28px;
					@media (max-width: 599px) {
						padding-left: 0px;
						padding-top: 0px;
						padding-bottom: 14px;
					}
					p {
						margin-bottom: 0px;
					}
					a {
						color: inherit;
						text-decoration: underline;
						text-underline-position: under;
						&:hover {
							color: #d9d9d9;
						}
					}
				}
			}
			&:last-child {
				border-bottom: 2px solid #999999;
			}
		}
	}
	.nx-another-way {
		button {
			background-color: transparent;
			padding: 0;
			border-top: none;
			border-left: none;
			border-right: none;
			border-bottom: 1px solid #0077ff;
			transition: all 0.3s;
			color: #0077ff;
			&:hover {
				color: #4ca1ff;
				border-bottom: 1px solid #4ca1ff;
				transition: all 0.3s;
			}
			&:disabled,
			&.disabled {
				color: rgba(204, 204, 204, 0.5);
				border-bottom: 1px solid rgba(204, 204, 204, 0.5);
				cursor: not-allowed;
			}
		}
	}
}
</style>
